var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7709 7.86236C13.7709 7.40546 13.7331 6.94608 13.6525 6.49658H7.18457V9.0849H10.8885C10.7348 9.91968 10.2409 10.6581 9.51776 11.1274V12.8068H11.7275C13.0251 11.6362 13.7709 9.90733 13.7709 7.86236Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.18442 14.4293C9.03384 14.4293 10.5935 13.8341 11.7299 12.8067L9.52013 11.1273C8.90534 11.5372 8.11165 11.7694 7.18694 11.7694C5.39799 11.7694 3.88116 10.5864 3.33692 8.99585H1.05664V10.7272C2.22072 12.9969 4.5917 14.4293 7.18442 14.4293Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.3343 8.99621C3.04707 8.16143 3.04707 7.25749 3.3343 6.42271V4.69141H1.05658C0.0840059 6.59066 0.0840059 8.82826 1.05658 10.7275L3.3343 8.99621Z",
    fill: "#FBBC04"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.18442 3.64647C8.16204 3.63165 9.10691 3.99224 9.81493 4.65414L11.7727 2.73513C10.533 1.5941 8.8877 0.966779 7.18442 0.986537C4.5917 0.986537 2.22072 2.419 1.05664 4.69118L3.3344 6.42249C3.87613 4.82949 5.39547 3.64647 7.18442 3.64647Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.f6bf30675d56dc66bba6937a83e1e92f.svg";
export { ForwardRef as ReactComponent };